module.exports = __webpack_public_path__ + "static/img/feedback.30f8c888.png";